<template>
  <div class="main role-page">
    <div class="main_r">
      <div class="page-top">
        <div class="title_line">角色管理</div>
      </div>

      <div class="role-body">
        <!-- 选择角色 -->
        <div class="role-panel role-panel--left">
          <div class="panel-header">
            <div class="panel-title">
              <i class="el-icon-user-solid"></i>
              <span>选择角色</span>
            </div>
            <el-tooltip effect="dark" content="添加角色" placement="top" :enterable="false">
              <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="clickdialogAdd()"></el-button>
            </el-tooltip>
          </div>
          <div class="panel-content">
            <ul class="role-list">
              <li
                v-for="(item, index) in choseSole"
                :key="index"
                :class="{ 'is-active': index == selectIndex }"
                @click="clickRole(item, index)"
              >
                <div class="role-info">
                  <i class="el-icon-user role-icon"></i>
                  <span class="role-name">{{ item.name }}</span>
                </div>
                <div class="role-actions">
                  <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" class="role-action-btn" @click.stop="clickdialogEdit(item)"></el-link>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                    <el-link :underline="false" type="danger" icon="el-icon-delete" class="role-action-btn" @click.stop="clickdialogDel(item)"></el-link>
                  </el-tooltip>
                </div>
              </li>
            </ul>
            <div v-if="choseSole.length === 0" class="role-empty">
              <i class="el-icon-user"></i>
              <p>暂无角色，请点击右上角添加</p>
            </div>
          </div>
        </div>
        <!-- 选择角色 End -->

        <!-- 权限分配 -->
        <div class="role-panel role-panel--right">
          <div class="panel-header">
            <div class="panel-title">
              <i class="el-icon-s-check"></i>
              <span>权限分配</span>
            </div>
            <el-tag v-if="choseSole.length > 0" size="small" type="info" effect="plain">
              {{ choseSole[selectIndex] ? choseSole[selectIndex].name : '' }}
            </el-tag>
          </div>
          <div class="panel-content">
            <div class="permission-tree-wrap">
              <el-tree
                ref="PermissionsTree"
                class="permission-tree"
                :data="classificationData"
                show-checkbox
                node-key="id"
                default-expand-all
                highlight-current
                :props="defaultProps"
              ></el-tree>
              <div v-if="classificationData.length === 0" class="tree-empty">
                <i class="el-icon-s-check"></i>
                <p>暂无权限数据</p>
              </div>
            </div>
          </div>
          <div class="panel-footer">
            <el-button type="primary" icon="el-icon-check" @click="SaveRole()">保存权限</el-button>
          </div>
        </div>
        <!-- 权限分配 End -->
      </div>
    </div>

    <!-- 添加角色 -->
    <el-dialog title="添加角色" :visible.sync="dialogAddRole" width="400px" class="newAdd">
      <div class="addUser_body">
        <el-form label-width="0">
          <el-form-item>
            <el-input v-model="roleName" placeholder="请输入角色名称" prefix-icon="el-icon-user" clearable maxlength="20" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddRole = false">取消</el-button>
        <el-button type="primary" @click="addRole()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加角色 End -->

    <!-- 编辑角色 -->
    <el-dialog title="编辑角色" :visible.sync="dialogEditRole" width="400px" class="newAdd">
      <div class="addUser_body">
        <el-form label-width="0">
          <el-form-item>
            <el-input v-model="roleName" placeholder="请输入角色名称" prefix-icon="el-icon-user" clearable maxlength="20" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditRole = false">取消</el-button>
        <el-button type="primary" @click="editRole()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑角色 End -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      // 权限分配
      classificationData: [],
      defaultProps: {
        children: 'children',
        label: 'permissionsName'
      },
      // 选择角色
      choseSole: [],
      checkedkeys: [],
      dialogAddRole: false,
      dialogEditRole: false,
      roleName: '',
      clickRoleId: 0,
      selectIndex: 0
    }
  },
  mounted () {
    this.getPermissionsTree()
    this.listRole()
  },
  methods: {
    clickdialogAdd () {
      this.dialogAddRole = true
      this.roleName = ''
    },
    clickdialogEdit (item) {
      this.dialogEditRole = true
      this.roleName = item.name
      this.clickRoleId = item.id
    },
    clickdialogDel (item) {
      var that = this
      this.$deleteConfirm('确定删除该角色？').then(function () {
        that.deleteRole(item.id)
      })
    },
    clickRole (item, index) {
      this.selectIndex = index
      this.clickRoleId = item.id
      this.getRolePermissions()
    },
    SaveRole () {
      this.saveRolePermissions()
    },
    listRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_listRole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.choseSole = response.data.data
            if (that.choseSole.length > 0) {
              that.clickRole(that.choseSole[0], 0)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.name = that.roleName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addRole, Qs.stringify(data))
        .then(function (response) {
          that.dialogAddRole = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddRole = false
        })
    },
    editRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.name = that.roleName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editRole, Qs.stringify(data))
        .then(function (response) {
          that.dialogEditRole = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEditRole = false
        })
    },
    deleteRole: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_deleteRole, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        }
        )
        .catch(function (error) {
          console.log(error)
        })
    },
    getPermissionsTree: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getPermissionsTree, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.classificationData = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveRolePermissions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.checkedKeys = that.$refs.PermissionsTree.getCheckedKeys().toString()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_saveRolePermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data.msg)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getRolePermissions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getRolePermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            var checkedkeys = []
            response.data.data.filter((item1, i1) => {
              checkedkeys.push(item1.permissionsId)
            })
            that.$refs.PermissionsTree.setCheckedKeys(checkedkeys)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  RoleManagement · 基于 DeviceManagement 设计规范
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.role-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 双栏布局 */
.role-body {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 16px;
  overflow: hidden;
}

/* 面板通用 */
.role-panel {
  display: flex;
  flex-direction: column;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(15, 26, 46, 0.06);
  overflow: hidden;
}

.role-panel--left {
  width: 320px;
  flex-shrink: 0;
}

.role-panel--right {
  flex: 1;
  min-width: 0;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid var(--aptus-border-light);
  background: var(--aptus-surface-muted);
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--aptus-text);

  i {
    font-size: 16px;
    color: var(--aptus-primary);
  }
}

.panel-content {
  flex: 1;
  min-height: 0;
  padding: 12px;
  overflow-y: auto;
}

.panel-footer {
  padding: 12px 18px;
  border-top: 1px solid var(--aptus-border-light);
  background: var(--aptus-surface-muted);
  display: flex;
  justify-content: flex-end;
}

/* 角色列表 */
.role-list {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 200ms ease;
    margin-bottom: 6px;
    border: 1px solid transparent;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background: var(--aptus-primary-bg);
      border-color: #A8D0F5;
    }

    &.is-active {
      background: var(--aptus-primary);
      border-color: var(--aptus-primary);
      box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);

      .role-icon {
        color: rgba(255, 255, 255, 0.9);
      }

      .role-name {
        color: #fff;
        font-weight: 600;
      }

      .role-action-btn {
        color: rgba(255, 255, 255, 0.85);

        &.el-link--primary:hover {
          color: #fff;
          background: rgba(255, 255, 255, 0.15);
        }

        &.el-link--danger:hover {
          color: #fff;
          background: rgba(255, 255, 255, 0.15);
        }
      }
    }
  }
}

.role-info {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.role-icon {
  font-size: 16px;
  color: var(--aptus-text-muted);
  flex-shrink: 0;
}

.role-name {
  font-size: 14px;
  color: var(--aptus-text);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.role-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  margin-left: 8px;
}

.role-action-btn {
  font-size: 14px;
  padding: 4px 5px;
  border-radius: 5px;
  transition: all 200ms ease;
  line-height: 1;

  &:hover {
    background-color: var(--aptus-primary-bg);
  }

  &.el-link--danger:hover {
    background-color: var(--aptus-danger-bg);
  }
}

.role-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: var(--aptus-text-muted);

  i {
    font-size: 40px;
    margin-bottom: 12px;
    opacity: 0.5;
  }

  p {
    font-size: 13px;
    margin: 0;
  }
}

/* 权限树 */
.permission-tree-wrap {
  height: 100%;
  overflow-y: auto;
}

.permission-tree {
  background: none;

  /deep/ .el-tree-node__expand-icon {
    color: var(--aptus-primary);
  }

  /deep/ .el-tree-node__content {
    height: 34px;
    border-radius: 4px;
    transition: background 200ms ease;

    &:hover {
      background: var(--aptus-primary-bg);
    }
  }

  /deep/ .el-tree-node__label {
    font-size: 13px;
    color: var(--aptus-text);
  }

  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: var(--aptus-primary);
    border-color: var(--aptus-primary);
  }

  /deep/ .el-checkbox__inner:hover {
    border-color: var(--aptus-primary);
  }
}

/* 子级叶子节点对齐优化 */
.permission-tree /deep/ .el-tree-node__children .el-tree-node__expand-icon {
  visibility: hidden;
  width: 0;
  margin: 0;
}

.permission-tree /deep/ .el-tree-node__children .el-tree-node__content {
  padding-left: 24px !important;
}

.tree-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: var(--aptus-text-muted);

  i {
    font-size: 40px;
    margin-bottom: 12px;
    opacity: 0.5;
  }

  p {
    font-size: 13px;
    margin: 0;
  }
}

/* 弹窗 · 与 DeviceManagement 保持一致 */
.confirmDel /deep/ .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.confirmDel /deep/ .el-dialog__body {
  padding: 20px 24px;
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.confirmDel /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.confirmDel /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.confirmMsg {
  font-size: 15px;
  color: var(--aptus-text);
  text-align: center;
  padding: 10px 0;
}

.confirm-icon {
  font-size: 48px;
  color: var(--aptus-warning);
  display: block;
  margin-bottom: 12px;
}

.confirm-tip {
  font-size: 12px;
  color: var(--aptus-text-muted);
  margin-top: 6px;
}

/* 新增/编辑弹窗 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.addUser_body {
  padding: 24px 30px 8px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--danger {
  color: #FFF;
  background-color: var(--aptus-danger);
  border-color: var(--aptus-danger);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #B71C1C;
    border-color: #B71C1C;
    box-shadow: 0 2px 8px rgba(198, 40, 40, 0.25);
  }
}

/* 响应式 */
@media (max-width: 992px) {
  .role-body {
    flex-direction: column;
  }

  .role-panel--left {
    width: 100%;
    max-height: 320px;
  }
}

@media (max-width: 768px) {
  .role-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }
}
</style>
